(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["keepset-event-invite"] && !Shopify.designMode) return;
  try {
    
  /*
   * A custom element rather than a DOMContentLoaded listener, because the theme editor
   * replaces a section's markup in place — a one-shot listener would leave the new buttons
   * dead until the page was reloaded.
   */
  class KeepsetEventInvite extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.packageField = this.querySelector('[data-ks-invite-package]');

      this.querySelectorAll('[data-ks-invite-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          // A card names its own package; the general button leaves the choice alone.
          const name = trigger.getAttribute('data-ks-package');
          if (name && this.packageField) this.packageField.value = name;
          this.dialog.showModal();
        });
      });

      this.querySelectorAll('[data-ks-invite-close]').forEach((trigger) => {
        trigger.addEventListener('click', () => this.dialog.close());
      });

      // Clicking the backdrop is the same gesture as Escape, which `dialog` already handles.
      // The target is the dialog itself only when the click missed the panel inside it.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      // Submitting reloads the page, so the answer arrives with the dialog shut. Liquid
      // leaves a marker when this form is the one that posted; reopen onto the result.
      if (this.dialog.querySelector('[data-ks-invite-reopen]')) {
        this.dialog.showModal();
        const note = this.dialog.querySelector('.ks-formnote');
        if (note) note.focus();
      }
    }
  }

  if (!customElements.get('ks-event-invite')) {
    customElements.define('ks-event-invite', KeepsetEventInvite);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
